import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import VueCokie from 'vue-cookie'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import App from './App'
import router from './router/index'
import store from './store'
import i18n from '@/utils/i18n'
import VueMask from 'v-mask'

import VueKinesis from 'vue-kinesis'

import Multiselect from 'vue-multiselect'
import VCalendar from 'v-calendar'
import '@/utils/filters'
import config from '@/utils/configUtil'

// import componentsAside from '../src/components/aside/index'

import AsideSegments from '../src/components/aside/AsideSegments'
import BlocksLibrary from '../src/components/aside/BlocksLibrary'

Vue.component('AsideSegments', AsideSegments)
Vue.component('BlocksLibrary', BlocksLibrary)

Vue.directive('focus', {
  inserted: function (el) {
    el.focus()
  },
})

// Insere as configurações padrões no escopo global do vue
config().then((res) => {
  Vue.prototype.$configs = res
})

Vue.use(VueCokie)

Vue.use(VueMask, {
  // (!) custom placeholders support requires registration as a plugin to
  placeholders: {
    '#': null, // passing `null` removes default placeholder, so `#` is treated as character
    Y: /[a-zA-Z0-9_,\s.+ -]/, // define new placeholder
  },
})

Vue.use(VueKinesis)
Vue.use(CoreuiVue)
Vue.use(VCalendar, {
  componentPrefix: 'v',
})
Vue.component('multiselect', Multiselect)

const vueInstance = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  //CIcon component documentation: https://coreui.io/vue/docs/components/icon
  icons,
  template: '<App/>',
  components: {
    App,
  },
})

export default vueInstance
